import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { Heading } from '@aidkitorg/component-library'
import { DashboardBuilderPanel } from './components/DashboardBuilderPanel'

export const DashboardBuilderPage = () => {
  // TODO: make heading and description editable
  const headerContent = (
    <div>
      <Heading level="h1" className="m-0">My Dashboard</Heading>
      <div className="inline-block text-lg text-gray-700">
        A customizable dashboard for data visualization
      </div>
    </div>
  )

  // TODO: add modal and report selection, for now, just build from an empty page
  
  return (
    <AdminPanelPage
      headerContent={headerContent}
    >
      <div className="flex gap-4 h-full">
        <div className="flex-1">
          CONTENT
        </div>
        <div className="w-64 h-full border rounded-md bg-white">
          <DashboardBuilderPanel/>
        </div>
      </div>
    </AdminPanelPage>
  )
}